export const REVYRE = {
  COLLECT_IQ: {
    WORKFLOW_TYPES: ['batch', 'case', 'loan'],
    DOMAIN_TYPES: ['activity', 'workflow', 'approval', 'payment'],
    LIST_PAGE_CREATE_SCENARIO_BLOCKED_ENTITIES: ['ccase', 'loan', 'payment'],
    RESTRICT_HEADER_BUTTONS: ['loan'],
    DETAILS_PAGE_QUICK_ACTIONS_HIDDEN_RULES: {
      hiddenStatuses: [
        'COMPLETED',
        'PAYMENT_COMPLETED',
        'FULLY_PAID',
        'CANCELLED',
      ],
      hiddenByInputKey: 'suspended',
    },
    DETAILS_PAGE_CUSTOM_REFFERED_ENTITIES: ['payment'],
    STATUS_ERROR_CODE_WITH_DESCRIPTION: [50008],
  },
};

export const STATE_ID = 'stateId';
export const CASE = 'ccase';
export const LOAN = 'loan';

export const TAB_STATUS_KEYS = {
  RELATED_RECORDS: 'relatedRecords',
  DETAILS: 'details',
  AUDIT_HISTORY: 'auditHistory',
  TRAILS: 'trails',
  CASES: 'cases',
  HISTORY: 'history',
  ACTIVE_CASES: 'activeCases',
  SUSPENDED_CASES: 'suspendedCases',
};

export const DISPOSITION_GROUP = 'outcomeGroup';
